import React from 'react';
import { Button } from '../../../../../../../common/components/Button/Button';

class CheckboxTree extends React.PureComponent {
  render() {
    const { children, showSaveButton } = this.props;
    return (
      <div>
        <div className="scheme-three">{children}</div>
        {showSaveButton && (
          <div className="checkbox-three-btn-bar">
            <Button type="submit" bsStyle="primary" className="pull-right margin-top">
              Save Changes
            </Button>
          </div>
        )}
      </div>
    );
  }
}

export default CheckboxTree;
